/**
 * User-written text (project descriptions, CRA sections) rendered as plain text: line breaks
 * are kept by CSS, and React escapes everything — no HTML is ever injected.
 */
export function PlainText({ text, empty = "—", className }: { text: string | null | undefined; empty?: string; className?: string }) {
  const value = (text ?? "").trim();
  if (!value) return <p className={`ada-plaintext ada-faint ${className ?? ""}`.trim()}>{empty}</p>;
  return <p className={`ada-plaintext ${className ?? ""}`.trim()}>{value}</p>;
}
